// extracted by mini-css-extract-plugin
export default {"bg":"Q4iSzn","scotch":"O3uHGh"};